module.exports = __webpack_public_path__ + "assets/trip-black.c0787aca.svg";